// extracted by mini-css-extract-plugin
export var notYouBtn = "UserRecognizer-module--notYouBtn--e0f21";
export var wrapper = "UserRecognizer-module--wrapper--12dd9";